import { render } from "./LiquidationApprovalHistory.vue?vue&type=template&id=3157814c"
import script from "./LiquidationApprovalHistory.vue?vue&type=script&lang=js"
export * from "./LiquidationApprovalHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__